import dayjs from "dayjs";

export function formatTimestampFull(timestamp: string | Date): string {
  return dayjs(timestamp).format("LLLL");
}
